import cn from 'classnames';
import { Notifications } from '#components/patterns/notifications/Notifications.tsx';
import { useNotifications } from '#global/context/notifications/useNotifications.tsx';
import { PageHeader } from '../../page-header/PageHeader.tsx';
import styles from './FullpageLayout.module.css';

type Props = {
  header: React.ReactElement | string;
  children?: React.ReactNode;
  headerClass?: string;
};

export function FullpageLayout({ header, children, headerClass }: Props) {
  const headerElement = typeof header === 'string' ? <PageHeader title={header} /> : header;
  // Technically, <Notifications/> pulls this itself, but we want to know whether there are any,
  // so we can set a class name or not
  const { notifications } = useNotifications();
  return (
    <div className={cn(styles.FullpageLayout)}>
      <div className={cn({ [styles.FullpageLayout_notifications]: notifications.length })}>
        <Notifications />
      </div>
      <div className={cn(headerClass, styles.FullpageLayout_header)}>{headerElement}</div>
      <div className={styles.FullpageLayout_body}>{children}</div>
    </div>
  );
}
